import React, { Component, ErrorInfo, ReactNode } from 'react';
import { logger } from '@/Util/globals';
import GridContainer from '@/Layouts/GridContainer';
import { notFound, useRouter } from 'next/navigation';
import { MagnoliaSite } from '@/types/cms/magnolia';

interface Props {
  children?: ReactNode;
  router: ReturnType<typeof useRouter>;
  siteConfig: MagnoliaSite;
  rootNodePath: string;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false
  };

  public static getDerivedStateFromError(_: Error): State {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    logger('error')('Uncaught error:', error, errorInfo);
    notFound();
  }

  public render() {
    if (this.state.hasError) {
      return (
        <GridContainer>
          <h2>There was an error during loading the page. Redirecting...</h2>
        </GridContainer>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
